import { CustomHttpErrorResponse } from '@rogers/self-serve-common';
import { TrackErrorData } from '@rogers/self-serve-analytics';
import { get } from 'lodash';

// eslint-disable-next-line
export function getErrorTrackingObject(error: CustomHttpErrorResponse): TrackErrorData {
  return {
    API: error.url,
    code: get(error, 'error.status.code', ''),
    field: '',
    type: 'http',
    category: 'self serve',
    message: get(error, 'error.status.codeName', ''),
  };
}
